import { z } from 'zod';
/** File metadata stored in container workflow draft stepData. */
export const workflowContainerFileMetadataSchema = z.object({
    objectKey: z.string().min(1).max(250).trim(),
    originalName: z.string().min(1).max(250).trim(),
    mimeType: z.string().min(1).max(100).trim(),
    size: z.number().int(),
    uploadedAt: z.union([z.string(), z.date()]).optional(),
});
export function resolveContainerImages(stepData) {
    return stepData.containerImages ?? [];
}
export function resolveContainerFiles(stepData) {
    return stepData.containerFiles ?? [];
}
export function resolveContainerImageObjectKeys(stepData) {
    return resolveContainerImages(stepData).map((img) => img.objectKey);
}
export function resolveContainerFileObjectKeys(stepData) {
    return resolveContainerFiles(stepData).map((file) => file.objectKey);
}
export function parseContainerImagesFromStepData(stepData) {
    if (!stepData) {
        return [];
    }
    const parsed = z.array(workflowContainerFileMetadataSchema).safeParse(stepData.containerImages);
    return parsed.success ? parsed.data : [];
}
export function parseContainerFilesFromStepData(stepData) {
    if (!stepData) {
        return [];
    }
    const parsed = z.array(workflowContainerFileMetadataSchema).safeParse(stepData.containerFiles);
    return parsed.success ? parsed.data : [];
}
//# sourceMappingURL=container-workflow-media.js.map